
import { VariantMeasurement } from "@/hooks/useVariantMeasurements";

export const variantMeasurementColumns = [
  {
    key: "part_name",
    label: "Part Name"
  },
  {
    key: "measurement_value",
    label: "Value"
  },
  {
    key: "description",
    label: "Description",
    render: (row: VariantMeasurement) => row.description || "N/A"
  },
  {
    key: "products",
    label: "Products",
    render: (row: VariantMeasurement) => {
      const products = row.products || [];
      return products.length > 0
        ? products.join(", ")
        : "None";
    }
  }
];
